import { PaginationControls, PaginationInfo } from '@/components/pagination/pagination'

import { cn } from '@/lib/utils'

import { NOTIFICATIONS_PER_PAGE } from '../../constants'

export interface GeneralUpdateListPaginationProps {
  currentPage: number
  totalCounts: number
  disabled?: boolean
  onChangePage: (page: number) => void
}

export const GeneralUpdateListPagination = ({
  currentPage,
  totalCounts,
  disabled,
  onChangePage,
}: GeneralUpdateListPaginationProps) => {
  const totalPages = Math.ceil(totalCounts / NOTIFICATIONS_PER_PAGE)

  return (
    <div className={cn('flex items-center justify-end')}>
      <PaginationInfo currentPage={currentPage} totalPages={totalPages} className={cn('mr-4')} />
      <PaginationControls
        currentPage={currentPage}
        totalPages={totalPages}
        disabled={disabled}
        onChange={onChangePage}
      />
    </div>
  )
}
